module.exports = __webpack_public_path__ + "media/audio1.2a6d364b.mp3";